import { Card, CardContent, CardHeader, CardTitle } from "@bcc/components/ui/card";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@bcc/components/ui/chart";
import { useTranslation } from "react-i18next";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";
import { setSalesChartContainerTestId, setSalesChartTitleTestId } from "./sales-chart.utils";

interface SalesData {
  month: string;
  orders: number;
}

interface SalesChartProps {
  data: SalesData[];
  testId?: string;
}

export function SalesChart({ data, testId }: SalesChartProps) {
  const { t } = useTranslation();
  return (
    <Card testId={testId ?? setSalesChartContainerTestId()}>
      <CardHeader>
        <CardTitle data-testid={setSalesChartTitleTestId()}>{t("components.salesChart.title")}</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer
          config={{
            orders: {
              label: t("components.salesChart.ordersLabel"),
              color: "hsl(var(--chart-2))",
            },
          }}
          className="h-[300px]"
        >
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis dataKey="month" className="text-xs" tickLine={false} axisLine={false} />
            <YAxis className="text-xs" tickLine={false} axisLine={false} />
            <ChartTooltip content={<ChartTooltipContent />} />
            <Bar dataKey="orders" fill="hsl(var(--chart-2))" radius={[8, 8, 0, 0]} />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
